// ============================================================
// EnvironmentFavicon.tsx
// Altera o favicon baseado no ambiente
// Coloque em: FillSign.App/src/components/EnvironmentFavicon.tsx
// ============================================================

import { useEffect } from 'react';

const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT || 'development';

// Mascote FillSign como favicon em todos os ambientes (arquivos em /public).
// dev/uat recebem um badge colorido no canto para diferenciar as abas.
const FAVICONS = {
  development: '/favicon-dev.png',
  staging: '/favicon-uat.png',
  production: '/favicon.png',
};

const normalizeEnvironment = (env: string): 'development' | 'staging' | 'production' => {
  const normalized = env.toLowerCase();
  if (normalized === 'dev' || normalized === 'development') return 'development';
  if (normalized === 'uat' || normalized === 'staging') return 'staging';
  return 'production';
};

export const EnvironmentFavicon: React.FC = () => {
  useEffect(() => {
    const env = normalizeEnvironment(ENVIRONMENT);
    const faviconUrl = FAVICONS[env];
    
    // Atualizar ou criar link do favicon
    let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = faviconUrl;
    link.type = 'image/png';

    // Também atualizar apple-touch-icon se existir
    const appleIcon = document.querySelector<HTMLLinkElement>('link[rel="apple-touch-icon"]');
    if (appleIcon) {
      appleIcon.href = faviconUrl;
    }
  }, []);

  return null;
};

export default EnvironmentFavicon;
